<template>
  <div class="info-wrapper">

    <div v-if="isHovered" class="card w-100">
      <div class="card-body">
        <h5 class="card-title info-title">Version</h5>
        <p class="card-text text-sm-center">{{ version }}</p>
      </div>
    </div>

    <div class="info-version-box" @mouseover="isHovered = true" @mouseleave="isHovered = false">
      <img src="../../../static/img/components-icons/info.svg" alt="icone de informação"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AppVersion',
  data() {
    return {
      isHovered: false,
      version: ''
    }
  },
  mounted() {
    const pjson = require('../../../package.json')
    this.version = pjson.version
  }
}
</script>

<style scoped>
.info-wrapper {
  min-width: 61px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-items: center;
  position: absolute;
  bottom: 12px;
  right: 12px;
  max-width: 150px;
}

.info-title {
  white-space: nowrap;
}

.info-version-box {
  display: flex;
  background: #211858;
  border-radius: 50%;
  max-width: 30px;
  max-height: 30px;
  transition: box-shadow 1s;
}

.info-version-box:hover {
  box-shadow: 1px 1px 19px 2px #7030C5;
}

img {
  height: 100%;
  width: 100%;
  filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(241deg) brightness(99%) contrast(103%);
}
</style>



// WEBPACK FOOTER //
// AppVersion.vue?d28b9890